module.exports = __webpack_public_path__ + "img/post-abstract.2a5c379.svg";